/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AuditoryPerceptionLevelEnum } from './auditoryPerceptionLevelEnum';
import { BlankEnum } from './blankEnum';
import { FineMotorLevelEnum } from './fineMotorLevelEnum';
import { GenderEnum } from './genderEnum';
import { GrossMotorLevelEnum } from './grossMotorLevelEnum';
import { NullEnum } from './nullEnum';
import { VisualPerceptionLevelEnum } from './visualPerceptionLevelEnum';

export interface TransitionReport { 
    readonly id: number;
    firstName: string;
    lastName: string;
    birthDate: string;
    streetAndHouseNumber?: string;
    city?: string;
    district?: string;
    postalCode?: string;
    country?: string;
    interests?: string;
    compLearningDescribesSuccess?: boolean;
    compLearningSeeksHelp?: boolean;
    compLearningPersists?: boolean;
    compCommunicationExpressesClearly?: boolean;
    compCommunicationListens?: boolean;
    compCommunicationUsesLanguage?: boolean;
    compSocialKnowsStrengths?: boolean;
    compSocialCooperates?: boolean;
    compSocialResolvesConflicts?: boolean;
    compCitizenshipReflects?: boolean;
    compCitizenshipCreatesRules?: boolean;
    compCitizenshipEmpathy?: boolean;
    compWorkPlans?: boolean;
    compWorkCompletes?: boolean;
    compWorkFollowsRules?: boolean;
    compProblemSolvingProposes?: boolean;
    compProblemSolvingDescribes?: boolean;
    compProblemSolvingSeeksAlternatives?: boolean;
    compCulturalParticipates?: boolean;
    compCulturalUnderstandsValues?: boolean;
    compCulturalRespectsDiversity?: boolean;
    compDigitalUsesTools?: boolean;
    compDigitalUnderstandsPurpose?: boolean;
    compDigitalFollowsRules?: boolean;
    additionalStrengths?: string;
    methodText?: string;
    methodSpeakingListening?: boolean;
    methodDemonstration?: boolean;
    methodManipulation?: boolean;
    methodRolePlay?: boolean;
    methodLearningByRules?: boolean;
    methodCreativeLearning?: boolean;
    methodReflection?: boolean;
    methodGroupLearning?: boolean;
    methodDigitalSupport?: boolean;
    orgFormCollective?: boolean;
    orgFormGroup?: boolean;
    orgFormActivityCenters?: boolean;
    orgFormIndividual?: boolean;
    orgFormFreePlay?: boolean;
    orgFormOutdoor?: boolean;
    orgFormCircleTime?: boolean;
    orgFormRoutine?: boolean;
    orgFormProject?: boolean;
    familyCooperation?: string;
    socioemotionalSupportNeeded?: boolean;
    socioemotionalNotes?: string;
    languageSupportNeeded?: boolean;
    languageNotes?: string;
    grossMotorSupportNeeded?: boolean;
    grossMotorLevel?: GrossMotorLevelEnum | BlankEnum;
    readonly grossMotorDiagnosticDate: string;
    grossMotorNotes?: string;
    fineMotorSupportNeeded?: boolean;
    fineMotorLevel?: FineMotorLevelEnum | BlankEnum;
    readonly fineMotorDiagnosticDate: string;
    fineMotorNotes?: string;
    visualPerceptionSupportNeeded?: boolean;
    visualPerceptionLevel?: VisualPerceptionLevelEnum | BlankEnum;
    readonly visualPerceptionDiagnosticDate: string;
    visualPerceptionNotes?: string;
    auditoryPerceptionSupportNeeded?: boolean;
    auditoryPerceptionLevel?: AuditoryPerceptionLevelEnum | BlankEnum;
    readonly auditoryPerceptionDiagnosticDate: string;
    auditoryPerceptionNotes?: string;
    supportMeasuresRecommended?: boolean;
    readonly created: Date;
    readonly modified: Date;
    readonly childGender: GenderEnum | BlankEnum | NullEnum;
}